module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.exercisesForProgress.length == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.subgroups.emptyExercises')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.exercisesForProgress
    }
  }, _vm._l((_vm.exercisesForProgress), function(exer) {
    return _c('li', {
      key: exer.id,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row my-margin"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('a', {
      staticStyle: {
        "color": "#d2d6de"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleExercisePredview(exer.exerciseId)
        }
      }
    }, [_vm._v(_vm._s(exer.exercise.identifier))]), _vm._v(" "), _c('span', {
      staticClass: "badge bg-green",
      staticStyle: {
        "margin-left": "0.5em"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeVisibility(exer)
        }
      }
    }, [_c('i', {
      class: ['fa', exer.visible ? 'fa-eye' : 'fa-eye-slash']
    })])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('span', {
      staticClass: "badge bg-red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteExercise(exer.exerciseId, _vm.podgrupa.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "margin"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExercises()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.addExercises')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "pull-right box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeDropdown()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73b50876", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73b50876"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/ExercisesInOrder.vue
// module id = 1449
// module chunks = 1